/**
 * Logout Route
 * Public route that performs logout and redirects
 *
 * Note: This handles the logout process by triggering side effects
 * The actual Logout component from Routes.jsx performs the logout logic
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/logout')({
  // No beforeLoad - public route
  // Component will handle logout logic
});
